import moment from 'moment';
import { IDN } from '../features/reporting/project-cases-by-day/project-cases-by-day.types';
import { Customer } from './customer';
import { Field } from './field';
import { Model } from './model';

export class Request extends Model<Request> {
  caseName?: string;
  clientName?: string;
  clientAddress?: string;
  clientPhone?: string;
  clientMail?: string;
  ProjectId?: string;
  ApartmentId?: string;
  description?: string;
  apartmentNumber?: string;
  projectName?: string;
  ClientId?: string;
  Client?: IDN;
  requestTime: number;

  FieldId: number;
  Field?: Field;

  CustomerId: number;
  migrated: boolean;

  Customer?: Customer;

  consentedToArticleId?: string;
  consentedToArticleIdAt?: Date;

  get date(): Date {
    return moment.unix(this.requestTime).toDate();
  }
}
